module.exports = __webpack_public_path__ + "static/TandemLaunch_Logo_high_resolution-7dcc91bf0d7796c3d979741f4266a39d.png";